export enum NftStatus {
	Initiated = 'INITIATED',
	TxSubmitted = 'TX_SUBMITTED',
	TxConfirmed = 'TX_CONFIRMED',
	TxFailed = 'TX_FAILED',
}
